var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSubmitEntryBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 42,
    viewBox: "0 0 119 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 42
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0 7.13898L5.23801 2.98898L31.568 2.98898L35.087 0L49.433 0L40.849 7.29398L0 7.13898L0 7.13898Z",
    fill: "#FFFFFF",
    transform: "translate(67.356 33.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M49.436 0.154007L44.198 4.304L17.868 4.304L14.349 7.29301L0 7.29301L8.58701 0L49.436 0.154007L49.436 0.154007Z",
    fill: "#FFFFFF",
    transform: "translate(1.991 0.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.70099 0L7.69498 0L0 6.53601L4.457 6.53601L7.70099 3.78L7.70099 0L7.70099 0Z",
    fill: "#FFFFFF",
    transform: "translate(111.299 35.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0 6.53601L0.0059967 6.53601L7.70099 0L3.244 0L0 2.756L0 6.53601L0 6.53601Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.746 2.05899L47.068 2.05899L49.494 0L0 0L2.746 2.05899L2.746 2.05899Z",
    fill: "#FFFFFF",
    transform: "translate(46.49 0.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29901 0L0 0L0 1.43799L3.29901 1.43799L3.29901 0L3.29901 0Z",
    fill: "#FFFFFF",
    transform: "translate(0.553 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29901 0L0 0L0 1.43802L3.29901 1.43802L3.29901 0L3.29901 0Z",
    fill: "#FFFFFF",
    transform: "translate(0.553 14.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29901 0L0 0L0 1.43802L3.29901 1.43802L3.29901 0L3.29901 0Z",
    fill: "#FFFFFF",
    transform: "translate(0.553 17.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29901 0L0 0L0 1.43799L3.29901 1.43799L3.29901 0L3.29901 0Z",
    fill: "#FFFFFF",
    transform: "translate(0.553 20.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29901 0L0 0L0 1.43799L3.29901 1.43799L3.29901 0L3.29901 0Z",
    fill: "#FFFFFF",
    transform: "translate(0.553 22.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29901 0L0 0L0 1.43799L3.29901 1.43799L3.29901 0L3.29901 0Z",
    fill: "#FFFFFF",
    transform: "translate(0.553 25.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29901 0L0 0L0 1.43802L3.29901 1.43802L3.29901 0L3.29901 0Z",
    fill: "#FFFFFF",
    transform: "translate(0.553 28.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29999 0L0 0L0 1.43799L3.29999 1.43799L3.29999 0L3.29999 0Z",
    fill: "#FFFFFF",
    transform: "translate(115.139 12.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29999 0L0 0L0 1.43802L3.29999 1.43802L3.29999 0L3.29999 0Z",
    fill: "#FFFFFF",
    transform: "translate(115.139 14.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29999 0L0 0L0 1.43802L3.29999 1.43802L3.29999 0L3.29999 0Z",
    fill: "#FFFFFF",
    transform: "translate(115.139 17.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29999 0L0 0L0 1.43799L3.29999 1.43799L3.29999 0L3.29999 0Z",
    fill: "#FFFFFF",
    transform: "translate(115.139 20.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29999 0L0 0L0 1.43799L3.29999 1.43799L3.29999 0L3.29999 0Z",
    fill: "#FFFFFF",
    transform: "translate(115.139 22.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29999 0L0 0L0 1.43799L3.29999 1.43799L3.29999 0L3.29999 0Z",
    fill: "#FFFFFF",
    transform: "translate(115.139 25.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.29999 0L0 0L0 1.43802L3.29999 1.43802L3.29999 0L3.29999 0Z",
    fill: "#FFFFFF",
    transform: "translate(115.139 28.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M108.061 41.39L10.639 41.39L0 32.354L0 9.036L10.639 0L108.061 0L109.928 1.58501L109.52 1.93201L107.824 0.490997L10.876 0.490997L0.576004 9.24001L0.576004 32.152L10.876 40.901L107.824 40.901L118.124 32.152L118.124 9.24001L116.323 7.71101L116.731 7.364L118.699 9.036L118.699 32.354L108.061 41.39L108.061 41.39Z",
    fill: "#FFFFFF",
    transform: "translate(0.263 0.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.5579 1.08699C2.5579 1.30199 2.48289 1.51199 2.3429 1.69099C2.20188 1.86899 2.00291 2.00899 1.7689 2.09099C1.53489 2.17299 1.2779 2.194 1.02988 2.153C0.781898 2.11099 0.553902 2.00699 0.374886 1.855C0.1959 1.70299 0.0738907 1.50999 0.0248795 1.299C-0.0251083 1.088 0.000892639 0.869995 0.0969009 0.67099C0.193886 0.472992 0.357887 0.302994 0.568886 0.18399C0.778908 0.0639954 1.02589 0 1.27891 0C1.6189 0 1.94389 0.11499 2.18391 0.319C2.4239 0.521988 2.5579 0.798996 2.5579 1.08699C2.5579 1.08699 2.5579 1.08699 2.5579 1.08699Z",
    fill: "#FFFFFF",
    transform: "translate(109.516 1.445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubmitEntryBtn);
export default __webpack_public_path__ + "static/media/iconSubmitEntryBtn.2103f3a8788d4b0fe83406ae2d4dcad0.svg";
export { ForwardRef as ReactComponent };